import { CSSProperties } from 'react';
import theme from '../../themes/index.en';

const { palette, typography } = theme;
 
export const MenuStyles = {
  navbar: {
   // background: `linear-gradient(to right, ${palette.primary.main}, ${palette.secondary.main})`,
  } as CSSProperties,
  navbarNav: {
    display: 'flex',
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
  submenuItemHover: { 
    color: palette.text.secondary,
    borderRadius: theme.shape.borderRadius,
    padding: '10px',
    transition: 'transform 0.3s ease, background-color 0.3s ease',
    '&:hover': {
      transform: 'rotate(3deg)',  
    },
  },  
  navItem: {
    position: 'relative' as 'relative',
    marginRight: '20px',
    padding: '10px 0',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    borderBottom: '2px solid transparent',
  },
  userNavItem: {
    position: 'relative' as 'relative', 
    padding: '10px 0',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    borderBottom: '2px solid transparent',
    marginLeft: '1390px'
  },
  navItemLast: {
    marginRight: 0,
  },
  navItemActive: {
    borderBottomColor: palette.secondary.main,
  },
  navItemHover: {
    borderBottomColor: palette.text.secondary,
  },
  navLink: {
    color: palette.text.secondary,
    textDecoration: 'none',
    fontFamily: typography.fontFamily,
    fontSize: '16px',
    fontWeight: 600,
  },
  submenu: {
    display: 'none',
    position: 'absolute' as 'absolute',
    top: '100%',
    left: '-50px', 
    backgroundColor: palette.background.paper,
    padding: '10px', 
    zIndex: 1000,
    borderRadius: theme.shape.borderRadius,
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  },
  submenuItem: {
    display: 'block', 
    padding:'5px'
  },
  submenuLink: {
    color: palette.text.primary,
    textDecoration: 'none',
    display: 'block',
    fontFamily: typography.fontFamily,
    fontSize: '14px',
    transition: 'color 0.3s ease',
    '&:hover': {
      backgroundColor: palette.secondary.main
    },
  }, 
  navLinkIcon: {
    marginRight: '5px',
  },
  logoContainer: {
    marginTop:'75px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '60px',
    padding: '10px',
    backgroundColor: 'transparent', 
  },
  logoStyle: {
    height: '150px',
  },
};
